import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WelcomeComponent } from './routes/welcome/welcome.component';
import { AppGuard, ConditionalGuard, WelcomeGuard } from './shared/guards';
import { TenantAccessGuard } from './shared/guards/tenant-access';

const routes: Routes = [
    {
        path: 'tenant-access',
        canActivate: [TenantAccessGuard],
        loadComponent: (): any =>
            import('./features/tenant-access/tenant-access.component').then(
                (mod) => mod.TenantAccessComponent,
            ),
    },
    {
        path: '',
        component: WelcomeComponent,
        pathMatch: 'full',
        canActivate: [WelcomeGuard],
    },
    {
        path: ':tenant',
        canActivate: [AppGuard, ConditionalGuard],
        loadChildren: (): any =>
            import('./routes/app-route/app-route.module').then(
                (m) => m.AppRouteModule,
            ),
    },
    {
        path: '**',
        redirectTo: '',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            paramsInheritanceStrategy: 'always',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
